module.exports = __webpack_public_path__ + "img/greycross.f95e12fd.svg";